module.exports = __webpack_public_path__ + "static/media/8OLA11.0de77af9.jpg";